import {
    addRolePermission,
    createRole,
    deleteRole,
    deleteRolePermission,
    editRole,
    getRole,
    getRoleById,
    openRole,
    removeRole,
    searchRoles,
} from './role.action';

export { roleReducer } from './role.reducer';
export { watchRole } from './role.saga';

export const roleActions = {
    createRole,
    editRole,
    getRole,
    deleteRole,
    getRoleById,
    searchRoles,
    openRole,
    removeRole,

    addRolePermission,
    deleteRolePermission,
};
